import React, { Component } from "react";
import { withRouter } from "react-router";
import { Row, Modal, Icon } from "antd";
import { connect } from "react-redux";
import moment from "moment";
import { LinkTo, AccountNameWrapper, GeneralCustomDiv } from "../../../../CommonComponents/commonStyles";
import {
  DefaultIndicator,
  CancelButton,
  SaveButton,
  ModalButtonContainer,
  ProfileTable,
  ShowDataButton
  
} from "../../styles";
import ExpandedRow from "./ExpandedRow/ExpandedRow";
import { accountChange } from "../../../../actions/globalActions";
import { getPrimaryAccount } from '../../../../utils/sessionUtil';
import { recordError } from "../../../../utils/commonUtil";
import PropTypes from 'prop-types';
import { tableDerivedStates } from "../../selectors";
import { CapsuleButton, GeneralButton } from "../../../../CommonComponents/Commons/commonComponents";

let expandProps = [];

class TableComponent extends Component {
  constructor(props){
    super(props);
    this.state = {
      filteredInfo: null,
      sortedInfo: null,
      selectedTableData: "",
      tableData: [],
      accountName: [],
      modalVisible: false,
      accountId: "",
      selectedOption: { accountID: "" },
      expandedRow: []
    };    
  }

  handleDefaultClick = () => {
    this.props.history.push({
      pathname: '/'
    })
  }

  handleChange = (pagination, filters, sorter, extra) => {
    const { exportAccountInfoDetails } = this.props;
    exportAccountInfoDetails({ sorter, extra })
    this.setState({
      sortedInfo: sorter
    });
  };

  setAgeSort = () => {
    this.setState({
      sortedInfo: {
        order: "descend",
        columnKey: "accountNumber"
      }
    });
  };  

  compareByAlph = (a, b) => {
    if (a > b) {
      return -1;
    }
    if (a < b) {
      return 1;
    }
    return 0;
  };

  // Modal starts
  showModal = value => {
    this.setState({
      modalVisible: true,
      accountId: value
    });
  };  

  handleOk = e => {

    const { onAccountChange } = this.props;

    this.setState({
      modalVisible: false
    });

    onAccountChange({
      accountID: this.state.accountId.toString()
    });    

  };

  handleCancel = e => {
    this.setState({
      modalVisible: false
    });
  };
  // Modal ends

  expandToggler(value = '') {
    this.setState({
      expandedRow: value >= 0 ? [value] : []
    });
  }

  render() {
    let { sortedInfo } = this.state;    
    sortedInfo = sortedInfo || {};
    const { TableData } = this.props;
    let key;

    {TableData.forEach((obj,index)=>{
      if(typeof TableData != 'null' && typeof TableData == 'object')
        obj.key = index;
        obj.dateOp= obj.dateOpened ? moment(moment.tz(parseInt(obj.dateOpened), "America/New_York")).format("MM/DD/YYYY"): '--'; 
    })}

    {TableData.forEach(obj=>{
      if(typeof TableData != 'null' && typeof TableData == 'object') obj.bal="$" +
      Number(obj.balance).toLocaleString(
        undefined,
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      )
    })}


    const NestedTable = (record, index, indent, expanded) => {
      return (
        <Row data-test="tableComponent" className="prfExpandTable">
          <ExpandedRow record={record} countries={this.props.countries} />
        </Row>
      );
    };

    function collapseExpand() {      
      expandProps.forEach((item) => item.props.onExpand(item.props.record, item.elem));
      expandProps = [];
    }

    const columndata = [
      {
        title: "Account Number",
        dataIndex: "accountNumber",
        key: "accountNumber",        
        sorter: (a, b) => {                
          collapseExpand();
          return this.compareByAlph(a.accountNumber, b.accountNumber);
        },
        sortOrder: sortedInfo.columnKey === "accountNumber" && sortedInfo.order
      },
      {
        title: "Account Name",
        dataIndex: "accountName",
        key: "accountName",
        sorter: (a, b) => {
          collapseExpand();
          return this.compareByAlph(a.accountName, b.accountName);
        },
        sortOrder: sortedInfo.columnKey === "accountName" && sortedInfo.order,
        render: (value, record) => {   
          if (record.primary =="1") {
            return (
              <AccountNameWrapper>
                <span>
                  <LinkTo id={"anrAccountName"+ record.key} onClick={() => { 
                    try {
                      if(getPrimaryAccount().userId == record.accountId)
                        this.handleDefaultClick();
                      else
                        this.showModal(record.accountId);
                    } catch (error) {
                      recordError(error);
                    }
                  }}>
                    {value}
                  </LinkTo>
                  {<DefaultIndicator>DEFAULT</DefaultIndicator>}
                </span>
              </AccountNameWrapper>
            );
          } else {
            return (
              <LinkTo id={"anrAccountName"+ record.key} onClick={() => { 
                try {
                  if(getPrimaryAccount().userId == record.accountId)
                    this.handleDefaultClick();
                  else
                    this.showModal(record.accountId);
                } catch (error) {
                  recordError(error);
                }
              }}>
                {value}
              </LinkTo>
            );
          }
        }
      },
      {
        title: "Date opened",
        dataIndex: "dateOp",
        key: "dateOp",

        sorter: (a, b) => {
          collapseExpand();
          return this.compareByAlph(a.dateOpened, b.dateOpened);
        },
        sortOrder: sortedInfo.columnKey === "dateOp" && sortedInfo.order
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
        sorter: (a, b) => {
          collapseExpand();
          return this.compareByAlph(a.role, b.role);
        },
        sortOrder: sortedInfo.columnKey === "role" && sortedInfo.order
      },
      {
        title: "Access Level",
        dataIndex: "access",
        key: "access",
        sorter: (a, b) => {
          collapseExpand();
          return this.compareByAlph(a.access, b.access);
        },
        sortOrder: sortedInfo.columnKey === "access" && sortedInfo.order
      },
      {
        title: "Balance",
        dataIndex: "bal",
        key: "bal",

        sorter: (a, b) => {
          collapseExpand();
          return this.compareByAlph(a.bal, b.bal);
        },
        sortOrder: sortedInfo.columnKey === "bal" && sortedInfo.order
      },
      {
        title: "",
        dataIndex: "",
        key: ""
      }
    ];

    const CustomExpandIcon = (props) => {
      return (
        props.expanded === true ? (
          <GeneralCustomDiv prfShowMore>
            <CapsuleButton
              text="Show Less"
              iconType="arrowUp"
              id={"btnShowLess" + props.record.key}
              onClick={e => {
                if (props.key >= 0 && this.state.expandedRow && this.state.expandedRow.length) {
                  if (this.state.expandedRow[0] === props.key) {
                    this.expandToggler();
                  }
                }
              }}
              whiteBackground={true}
            />
          </GeneralCustomDiv>
        ) : (
            <GeneralCustomDiv prfShowMore>
              <CapsuleButton
                text="Show More"
                iconType="arrowDown"
                id={`btnShowMoreTable ${props.record.key}`}
                onClick={() => { this.expandToggler(props.key) }}
                whiteBackground={true}
              />
            </GeneralCustomDiv>
          )
      );
    }
    
    return (
      <div>
        <ProfileTable
        data-test="mobileTableComponent"
          className="profileTable profileInfoTable"
          rowClassName={(record, index) => {
             if((index % 2) == 0) return 'grayScale';
             else return 'whiteScale';
          }}          
          onRow={(props) => {
            return {
              onClick: event => {
                if(props.key >= 0 && this.state.expandedRow && this.state.expandedRow.length) {
                  if(this.state.expandedRow[0] === props.key) {
                    this.expandToggler();
                  } else {
                    this.expandToggler(props.key);
                  }
                } else {
                  this.expandToggler(props.key);
                }
              }
            }
          }}
          columns={columndata}
          dataSource={TableData}
          expandedRowRender={NestedTable}
          onChange={this.handleChange}
          pagination={false}
          expandIcon={(props) => {return CustomExpandIcon(props)}} //sets the icon of expansion
          expandIconColumnIndex={6}
          expandIconAsCell={false}
          expandedRowKeys={this.state.expandedRow}
        />
        {TableData.map(obj => {
          if (this.state.accountId === obj.accountId) {
            return (
              <Modal
                title="Switch Account"
                visible={this.state.modalVisible}               
                onCancel={this.handleCancel}
                footer={[
                  <ModalButtonContainer>
                    <GeneralButton
                      text="Cancel"
                      type="functional"
                      width="9.375rem"
                      disabled={false}
                      id={`btnCancel${obj.key}`}
                      onClick={this.handleCancel}
                      inverted={true}
                    />
                    <GeneralButton
                      text="Continue"
                      type="functional"
                      width="9.375rem"
                      disabled={false}
                      id={`btnContinue${obj.key}`}
                      onClick={this.handleOk}
                      inverted={false}
                    />
                  </ModalButtonContainer>
                ]}
              >
                <p>
                  You are about to switch to account {obj.accountName}{" "}
                  <b>{obj.accountNumber}</b>
                  <br />
                  This will take you to the account page.
                  <br />
                  Do you want to continue?
                </p>
              </Modal>
            );
          }
        })}
      </div>
    );
  }
}

TableComponent.propTypes = {
  TableData: PropTypes.arrayOf(PropTypes.object),
  countries: PropTypes.arrayOf(PropTypes.object),
  eventaction: PropTypes.func,
  analyticsTracking: PropTypes.func
}

const mapStateToProps = (state,props) => {
  return {
    ...tableDerivedStates(state.toJS(),props)
  };
};

export const mapDispatchToProps = dispatch => ({
  onAccountChange: data => dispatch(accountChange(data))  
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TableComponent)
);